import { useTranslation } from 'react-i18next';

import { PropsWithClassname } from '@/app/types';

interface SubprojectParentBoxProps extends PropsWithClassname {
  parentTitle: string;
}

const SubprojectParentBox = ({ parentTitle, className }: SubprojectParentBoxProps) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <span className="block font-medium">{t('components.SubprojectParentBox.text')}</span>
      <span>{parentTitle}</span>
    </div>
  );
};

export default SubprojectParentBox;
